import * as React from "react";
import { useEffect, useState, useMemo, useCallback } from "react";
import { useDataProvider } from "react-admin";
import useAiInsight from "../../../Components/AiAssistant/useAiInsight";
import { buildAiBaseParams } from "../../../Components/AiAssistant/buildAiBaseParams";
import { Typography } from "@material-ui/core";
import GaugeChart from "../../../Components/CustomChart/GaugeChart";

const CockpitRequestAircraft = ({ filterParams }) => {
  const dataProvider = useDataProvider();

  const [chartValue, setChartValue] = useState(0);

  const resourceEndpoint = "pbhrequestorders/cockpit/requestaircraft";

  const subArcs = [
    {
      limit: 20,
      color: "#5BE12C",
      showTick: true,
    },
  ];

  const insightParams = useMemo(() => {
    if (chartValue === 0) return null;
    return {
      ...buildAiBaseParams(filterParams),
      requestPerAircraftRatio: chartValue.toFixed(2),
    };
  }, [filterParams, chartValue]);
  useAiInsight("cockpitrequestaircraft", insightParams);

  const GetChartData = useCallback(async () => {
    await dataProvider
      .getList(resourceEndpoint, {
        pagination: { page: 1, perPage: 999999 },
        sort: { field: "id", order: "ASC" },
        filter: {
          ...{
            [`createdDate == null || createdDate >= "${filterParams.createdDate__gte}"`]: "test",
            createdDate__lte: filterParams.createdDate__lte,
          },
          ...(filterParams?.contractId__in && filterParams.contractId__in.length > 0
            ? { contractId__in: filterParams.contractId__in }
            : {}),
        },
      })
      .then(({ data }) => {
        if (data != null && data[0]?.result != null) setChartValue(data[0].result);
      })
      .catch(error => {
        console.log(error);
      });
  }, [filterParams, dataProvider]);

  useEffect(() => {
    GetChartData();
  }, [GetChartData]);

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Request / Aircraft
      </Typography>
      <GaugeChart value={chartValue} subArcs={subArcs} maxValue={200} formatTextValue="" />
      <br />
      <br />
    </>
  );
};

export default CockpitRequestAircraft;
